"use strict";

exports.__esModule = true;
exports.replaceWindowElement = replaceWindowElement;

var _windowWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/windowWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function replaceWindowElement(_ref) {
  var type = _ref.type,
      id = _ref.id,
      attributes = _ref.attributes,
      innerHTML = _ref.innerHTML,
      parentElement = _ref.parentElement;

  var removedElement = _windowWrapper["default"].document.getElementById(id);

  if (removedElement) {
    var parent = removedElement.parentNode;
    parent.removeChild(removedElement);
  }

  var addedElement = _windowWrapper["default"].document.createElement(type);

  addedElement.setAttribute('id', id);
  Object.keys(attributes).forEach(function (key) {
    return addedElement.setAttribute(key, attributes[key]);
  });

  if (innerHTML) {
    addedElement.innerHTML = innerHTML;
  }

  parentElement.appendChild(addedElement);
}